import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations.tsx';
import { SessionTableRow } from '@/components/events/detail/tabs/sessions/sessions-table/session-table-row.tsx';
import type { SessionDto } from '@/types/dtos/sessions/session.dto.ts';

export const SessionsTable = ({ sessions }: { sessions: SessionDto[] }) => {
  const t = useTranslations();

  return (
    <TableContainer>
      <Table
        sx={{
          'tableLayout': 'fixed',
          '& .icon-column': {
            width: '40px',
            paddingRight: 0,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell className="icon-column"></TableCell>
            <TableCell>{`${t('session.tableHeader')}`}</TableCell>
            <TableCell>{t('common.actors')}</TableCell>
            <TableCell>{t('common.media')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sessions.map((session, i) => (
            <SessionTableRow key={i} session={session} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
